import { render } from "./FileField.vue?vue&type=template&id=31a58306&scoped=true"
import script from "./FileField.vue?vue&type=script&lang=js"
export * from "./FileField.vue?vue&type=script&lang=js"

import "./FileField.vue?vue&type=style&index=0&id=31a58306&scoped=true&lang=css"

import exportComponent from "c:\\Clients\\VoterFly\\application\\VoterFly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a58306"]])

export default __exports__